import styled, { css } from "styled-components";
import { RiFilterFill } from "react-icons/ri";
import { IconButton, Button } from "@material-ui/core";
import { Close } from "@material-ui/icons";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const AllFiltersButton = styled.button`
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 36px;
  padding: 0 12px;
  background-color: #ffffff;
  border-radius: 3px;

  ${(props) =>
    props?.$isFilterActive
      ? css`
          color: #449be9;
          border: 1px solid rgba(68, 155, 233, 0.7);
          box-shadow: 0 2px 1px -1px rgb(68 155 233 / 12%);
        `
      : css`
          color: #969696;
          border: 1px solid rgba(0, 0, 0, 0.25);
          box-shadow: 0 2px 1px -1px rgb(0 0 0 / 12%);
        `}
`;

export const FilterIcon = styled(RiFilterFill)`
  margin-left: 5px;
  ${(props) =>
    props?.$isFilterActive
      ? css`
          color: #449be9;
        `
      : css`
          color: #969696;
        `}
`;

export const ModalOverlay = styled.main`
  background: rgba(1, 1, 1, 0.6);
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
  width: 100vw;
  height: 100vh;
`;

export const ModalContainer = styled.div`
  width: 40%;
  height: 60%;
  box-shadow: 0 0 60px rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  @media (max-width: 1228px) {
    width: 50%;
    height: 65%;
  }
`;

export const ModalHeader = styled.header`
  background-color: #3d9be9;
  width: 100%;
  height: 48px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1rem;
`;

export const ModalTitle = styled.h6`
  font-size: 1.15rem;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-weight: 500;
  line-height: 1.6;
  letter-spacing: 0.0075em;
  color: #fff;
`;

export const CloseButton = styled(IconButton).attrs({
  edge: "end",
  color: "inherit",
})``;

export const CloseIcon = styled(Close).attrs({
  style: { fill: "white" },
})``;

export const ModalContent = styled.div`
  background: var(--white);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 22px;

  overflow: auto;

  ::-webkit-scrollbar {
    width: 6px !important;
    height: 6px !important;
  }
  ::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.3);
  }
  ::-webkit-scrollbar-track {
    background: hsla(0, 0%, 100%, 0.1);
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 0 0.55rem;

  @media (max-height: 768px) {
    flex-direction: row;
    padding: 0;
    margin-top: 10px;
  }
`;

export const ApplyFilterButton = styled(Button).attrs({
  variant: "contained",
  color: "primary",
})`
  height: 42px;
  width: 100%;

  text-transform: uppercase;
  font-size: 13px;
  cursor: pointer;

  @media (max-height: 768px) {
    width: 45%;
  }
`;

export const ClearFilterButton = styled(Button).attrs({
  variant: "outlined",
  color: "secondary",
})`
  height: 42px;
  width: 100%;
  margin-top: 18px;

  text-transform: uppercase;
  font-size: 13px;
  cursor: pointer;

  @media (max-height: 768px) {
    width: 45%;
    margin: 0 10px;
  }
`;
